import type { CustomRuleSearchParams } from '~/services/LuxLoyalty';

export const customRuleQueryKeys = {
  all: ['loyalty', 'custom-rules'] as const,
  searches: () => [...customRuleQueryKeys.all, 'search'] as const,
  search: (params: CustomRuleSearchParams) => [...customRuleQueryKeys.searches(), params] as const,
};
